import { render, staticRenderFns } from "./BlockType23.vue?vue&type=template&id=4b2a2894&scoped=true"
import script from "./BlockType23.vue?vue&type=script&lang=ts"
export * from "./BlockType23.vue?vue&type=script&lang=ts"
import style0 from "./BlockType23.vue?vue&type=style&index=0&id=4b2a2894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2a2894",
  null
  
)

export default component.exports